export default __webpack_public_path__ + "static/media/gallery.8c2bf014.svg";